<template>
  <v-container>
    <div><label>How often do you want your alert triggered?</label></div>
    <v-select
      :items="frequencyOptions"
      v-model="selectedValue"
      @change="selectedValueChanged"
      class="frequency-input"
      solo
      item-text="adverb"
      return-object
    ></v-select>
  </v-container>
</template>
<script>
import { FREQUENCY_OPTIONS } from "@/common/constants/alert.js";

const EMITTED_ACTIONS = {
  INPUT: "input",
};

export default {
  name: "FrequencyEditor",
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return this.frequencyOptions[0];
      },
    },
    alert: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      selectedValue: this.value
        ? JSON.parse(JSON.stringify(this.value))
        : JSON.parse(JSON.stringify(this.frequencyOptions[0])),
    };
  },
  methods: {
    selectedValueChanged(value) {
      this.$emit(EMITTED_ACTIONS.INPUT, value);
    },
  },
  computed: {
    frequencyOptions() {
      let opts = JSON.parse(JSON.stringify(FREQUENCY_OPTIONS));
      if (this.alert && this.alert.pulseEnabled) {
        opts = opts.filter((ele) => {
          return ele.id !== "15";
        });
      }
      return opts;
    },
  },
  watch: {
    value() {
      this.selectedValue = JSON.parse(JSON.stringify(this.value));
    },
    "alert.pulseEnabled": {
      handler() {
        if (
          this.alert &&
          this.alert.pulseEnabled &&
          this.selectedValue &&
          this.selectedValue.id === "15"
        ) {
          //fake value so that default doesn't populate and confuse user
          this.selectedValue = { id: "bad" };
          this.$set(this.alert, "frequency", this.selectedValue);
          this.selectedValueChanged(this.selectedValue);
        }
      },
      deep: true,
    },
    frequencyOptions: {
      handler() {
        if (
          !this.selectedValue ||
          JSON.stringify(this.selectedValue) === "{}" ||
          (this.selectedValue && this.selectedValue.id === "15")
        ) {
          this.selectedValue = this.frequencyOptions[0];
          this.selectedValueChanged(this.selectedValue);
        }
      },
    },
  },
};
</script>
<style scoped>
.frequency-input >>> .v-input__slot {
  border-radius: 5px !important;
}
</style>
